// Copyright 2018 Sorama B.V.

export class MeasurementProcessorTypes {
    public static beamformProbe = "BeamformProbe";
    public static timeRange = "TimeRange";
}
